import ProximaNovaRegularWoff from './proximanova/proximanova-regular-webfont.woff';
import ProximaNovaRegularWoff2 from './proximanova/proximanova-regular-webfont.woff2';
import ProximaNovaBoldWoff from './proximanova/proximanova-bold-webfont.woff';
import ProximaNovaBoldWoff2 from './proximanova/proximanova-bold-webfont.woff2';
import AquaticoWoff from './aquatico/aquatico-regular.woff';
import AquaticoWoff2 from './aquatico/aquatico-regular.woff2';

export const ProximaNovaRegular = {
    fontFamily: 'Proxima Nova',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontDisplay: 'swap',
    src: `
      url(${ProximaNovaRegularWoff2}) format('woff2'),
      url(${ProximaNovaRegularWoff}) format('woff')
    `
};

export const Aquatico = {
    fontFamily: 'Aquatico',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontDisplay: 'swap',
    src: `
      url(${AquaticoWoff2}) format('woff2'),
      url(${AquaticoWoff}) format('woff')
    `
};

export const ProximaNovaBold = {
    fontFamily: 'Proxima Nova',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontDisplay: 'swap',
    src: `
      url(${ProximaNovaBoldWoff2}) format('woff2'),
      url(${ProximaNovaBoldWoff}) format('woff')
    `
};
